import React from 'react';
import { Layout } from 'fronton-react';
import { HeaderSection, HeaderSectionText, SectionTitle } from 'common/components';
import {
  headerImage,
  headerSection,
  headerSectionCards,
  headerSectionText,
  headerSectionTitle,
} from './kitchen-header-styles';
import { KitchenHeaderCard } from '../kitchen-header-card';
import { KITCHEN_CDN_PATH } from '../../../kitchen-constants';

type KitchenHeaderProps = {
  isRuRegion: boolean;
  signUpHref: string;
}

export const KitchenHeader: React.FC<KitchenHeaderProps> = (
  { isRuRegion, signUpHref }
) => (
  <div className={headerSection}>
    <HeaderSection
      bgColor="#21282B"
      hasPattern={false}
      headerContent={(
        <HeaderSectionText className={headerSectionText}>
          <SectionTitle as="h1" className={headerSectionTitle} color="text-invert" size="extra">
            КУХНИ ПОД ВАШИ РАЗМЕРЫ БЫСТРО&nbsp;И&nbsp;ВЫГОДНО
          </SectionTitle>
        </HeaderSectionText>
      )}
      img={{
        alt: 'Изображение кухни',
        className: headerImage,
        ldSrcSet: `${KITCHEN_CDN_PATH}/header/header-ld.png/header-ld-01.png`,
        dSrcSet: `${KITCHEN_CDN_PATH}/header/header-d.png/header-d-01.png`,
        tSrcSet: `${KITCHEN_CDN_PATH}/header/header-t.png/header-t-01.png`,
        mSrcSet: `${KITCHEN_CDN_PATH}/header/header-m.png/header.png`,
      }}
      mediaType="image"
    />

    {isRuRegion && (
      <Layout className={headerSectionCards}>
        <KitchenHeaderCard signUpHref={signUpHref} />
      </Layout>
    )}
  </div>
);
